// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1081":"a5de2152","1259":"f6dd3c95","2237":"a5de2152","3119":"a5de2152","3918":"a5de2152","8646":"a5de2152"}[chunkId] + ".chunk.css";
};